import {
    Button, Dialog, DialogActions, DialogContent,
    DialogTitle, useMediaQuery, Grid, RadioGroup,
    TextField as MuiTextField
} from "@material-ui/core";
import React, { useState, useEffect } from 'react'
import { useAptorApi } from "../../../../../Api";
import { useIntl } from "react-intl";
import { AccessLevel, LawPortalFeature, UserContext } from "../../../../../Context/UserContext/UserContext";
import moment from "moment";
import { TextField, DateField } from "../../../../../Components/Field";
import { ComplianceReportCheckbox } from "../../../Components/Compliance/Checkbox";
import { TypedFormFieldValue } from "../../../../../Components/Form/Form.types";

interface Iprops {
    open: boolean
    setOpen: (val: boolean) => void;
    rowData: any
    onSaveSuccess?: () => void;
}

const EditObservationModal = ({ open, setOpen, rowData, onSaveSuccess }: Iprops) => {
    const { api } = useAptorApi();
    const { formatMessage } = useIntl();

    const [compliance, setCompliance] = useState<'yes' | 'no' | 'deficiency'>('deficiency');
    const [answer, setAnswer] = useState<TypedFormFieldValue<string>>();
    const [deadline, setDeadline] = useState<TypedFormFieldValue<Date>>();

    useEffect(() => {
        if (rowData && open) {
            setCompliance(rowData?.compliance);
            setAnswer({ value: rowData?.answer || '' });
            setDeadline(rowData?.deadline ? { value: moment(rowData.deadline).toDate() } : undefined);
        }
    }, [rowData, open]);

    const handleClose = () => setOpen(false);

    const handleSave = async () => {
        try {
            // TODO: Add API call to save observation
            // await api.updateObservation({ id: rowData?.id, compliance, answer: answer?.value, deadline: deadline?.value });
            onSaveSuccess?.();
            setOpen(false);
        } catch (error) {
            console.error('Error saving observation:', error);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="observation-dialog-title"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: {
                    borderRadius: '8px',
                    padding: '0',
                }
            }}
        >
            {/* Title */}
            <DialogTitle
                id="observation-dialog-title"
                disableTypography
                style={{ padding: '16px 24px 12px', borderBottom: '1px solid #e0e0e0' }}
            >
                <span style={{ fontSize: '16px', fontWeight: 500, color: '#1a1a1a' }}>
                    {formatMessage({ id: 'lawportal.evaluation-control.non-conformities.edit.modal.heading', defaultMessage: 'Handling of non conformity / observation' })}
                </span>
            </DialogTitle>

            <DialogContent style={{ padding: '16px 24px' }}>

                {/* Law reference */}
                <p style={{ fontSize: '13px', color: '#777', margin: '0 0 16px' }}>
                    {rowData?.number}, {rowData?.legislationName}
                </p>

                {/* Observation row: radio + description */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '24px', marginBottom: '20px' }}>
                    {/* Radio column */}
                    <div >
                        {rowData?.compliance === "deficiency" && (
                            <ComplianceReportCheckbox type="deficiency" value={rowData?.compliance} hidden={false} />
                        )}
                        {rowData?.compliance === "no" && (
                            <ComplianceReportCheckbox type="no" value={rowData?.compliance} hidden={false} />
                        )}
                    </div>

                    {/* Description text */}
                    <p style={{ fontSize: '14px', color: '#1a1a1a', margin: '0', lineHeight: 1.5 }}>
                        {rowData?.answer}
                    </p>
                </div>

                {/* Enter required action */}
                <div style={{ marginBottom: '20px' }}>
                    <TextField
                        name="answer"
                        label={formatMessage({
                            id: 'law-portal.observation.required.action',
                            defaultMessage: 'Enter required action'
                        })}
                        rows={4}
                        multiline
                        errorTexts={[]}
                        initialState={answer}
                        onChange={setAnswer}
                    />
                </div>

                {/* Bottom row: Uppfylld radio + date field */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                    <div style={{ minWidth: '70px' }}>
                        <RadioGroup
                            value={compliance}
                            onChange={(e) => setCompliance(e.target.value as 'yes' | 'no' | 'deficiency')}
                        >
                            <ComplianceReportCheckbox type="yes" value={compliance} hidden={false} />
                        </RadioGroup>
                    </div>

                    <div style={{ flex: 1, minWidth: '160px' }}>
                        <DateField
                            name="deadline"
                            errorTexts={[]}
                            placeholder={formatMessage({
                                id: 'law-portal.observation.date.action.placeholder',
                                defaultMessage: 'Enter date of action'
                            })}
                            initialState={deadline}
                            onChange={setDeadline}
                        />
                    </div>
                    <DialogActions style={{
                        //  padding: '8px 24px 16px', 
                         justifyContent: 'flex-end', 
                         justifyItems: 'center',
                         alignItems: 'center',
                         gap: '8px'
                          }}>
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                            style={{
                                border: '1.5px solid #e05a5a',
                                color: '#e05a5a',
                                fontWeight: 500,
                                letterSpacing: '0.5px',
                                minWidth: '80px',
                            }}
                        >
                            {formatMessage({ id: 'form.cancel', defaultMessage: 'AVBRYT' })}
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={handleSave}
                            style={{
                                border: '1.5px solid #e05a5a',
                                color: '#e05a5a',
                                fontWeight: 500,
                                letterSpacing: '0.5px',
                                minWidth: '80px',
                            }}
                        >
                            {formatMessage({ id: 'form.save', defaultMessage: 'SPARA' })}
                        </Button>
                    </DialogActions>
                </div>

            </DialogContent>

            {/* Actions */}
            {/* <DialogActions style={{ padding: '8px 24px 16px', justifyContent: 'flex-end', gap: '8px' }}>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                    style={{
                        border: '1.5px solid #e05a5a',
                        color: '#e05a5a',
                        fontWeight: 500,
                        letterSpacing: '0.5px',
                        minWidth: '80px',
                    }}
                >
                    {formatMessage({ id: 'form.cancel', defaultMessage: 'AVBRYT' })}
                </Button>
                <Button
                    variant="outlined"
                    onClick={handleSave}
                    style={{
                        border: '1.5px solid #e05a5a',
                        color: '#e05a5a',
                        fontWeight: 500,
                        letterSpacing: '0.5px',
                        minWidth: '80px',
                    }}
                >
                    {formatMessage({ id: 'form.save', defaultMessage: 'SPARA' })}
                </Button>
            </DialogActions> */}
        </Dialog>
    );
};

export default EditObservationModal;